/**
 * Turn a URL slug into a readable label for titles before DB data loads.
 * e.g. "royal-county-down-championship" → "Royal County Down Championship"
 */
export function slugToLabel(slug) {
  if (!slug || typeof slug !== 'string') return 'Golf course';
  return slug
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
